import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast, cssTransition } from "react-toastify";
import Loader from 'react-loader-spinner';
const Fade = cssTransition({
  enter: 'fadeIn',
  exit: 'fadeOut',
});
ToastContainer.defaultProps.transition = Fade;
ToastContainer.defaultProps.autoClose = 1500;
class ProjectPlanSettings extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      plans: [
        { "value": "Agent on website widget & popular social sales-desks,2 Languages(e.g English and Hindi),5 FAQs,1 Intent,Dashboard with reports,Delegate chat to humans,Unlimited messages,Upto 2 agents", "key": "FREE" },
        { "value": "Agent on website widget & popular social sales-desks,2 Languages(e.g English and Hindi),20 FAQs,5 Intents,Dashboard with reports,Delegate chat to humans,Unlimited messages", "key": "STARTER" },
        { "value": "Agent on website widget & popular social sales-desks,3 Languages,40 FAQs,10 Intents,Dashboard with reports,Delegate chat to humans,Unlimited messages", "key": "PROFESSIONAL" },
        { "value": "Agent on website widget & popular social sales-desks,6 Languages,90 FAQs,25 Intents,Dashboard with reports,Delegate chat to humans,Unlimited messages", "key": "PREMIUM" },
        { "value": "Agent on website widget & popular social sales-desks,9 Languages,More than 100 FAQs,More than 50 Intents,Dashboard with reports,Delegate chat to humans,Unlimited messages", "key": "ENTERPRISE" },
        { "value": "Automatic Speech Recognition APIs : 45 paise per 15 s,Natural Language Parsers APIs : 20 paise per API call [max 30 words billed as a unit call],Text Transliteration APIs : 10 paise per API call [max 30 words billed as unit call ]", "key": "API_PLAN" },
        { "key": "ENTERPRISE_PLUS" }],
      planValues: [],
      successResp: false,
      selectedPlan: '',
      updatedPlan: '',
      view: false,
      billingType: '',
      displayBackBtn: true
    }
    this.projectData = {
      projectId: null
    }
    this.moveToMainPageFunc = this.moveToMainPageFunc.bind(this);
    this.goBackToMainPage = this.goBackToMainPage.bind(this);

  }
  fetchSelectedProjectPlanApi = () => {
    var projectPlanController = this;
    var projectIdSent = null;
    if (projectPlanController.props.location.projectData != undefined) {
      projectIdSent = projectPlanController.props.location.projectData.projectId;
    } else {
      projectIdSent = localStorage.getItem("currentProjectId")
    }
    $.ajax({
      url: "/api/project-plan-details",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectIdSent
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        projectPlanController.state.successResp = true;
        if (res.result != null) {
          projectPlanController.setState({ selectedPlan: res.result });
          if (res.result == 'FREE') {
            for (var i = 0; i < document.getElementsByClassName("free1").length; i++) {
              document.getElementsByClassName("free1")[i].style.color = "#FFAA00";
            }
          } else if (res.result == 'STARTER') {
            for (var i = 0; i < document.getElementsByClassName("starter1").length; i++) {
              document.getElementsByClassName("starter1")[i].style.color = "#FFAA00";
            }
          } else if (res.result == 'PROFESSIONAL') {
            for (var i = 0; i < document.getElementsByClassName("profession1").length; i++) {
              document.getElementsByClassName("profession1")[i].style.color = "#FFAA00";
            }
          } else if (res.result == 'PREMIUM') {
            for (var i = 0; i < document.getElementsByClassName("premium1").length; i++) {
              document.getElementsByClassName("premium1")[i].style.color = "#FFAA00";
            }
          } else if (res.result == 'ENTERPRISE') {
            for (var i = 0; i < document.getElementsByClassName("enterprise1").length; i++) {
              document.getElementsByClassName("enterprise1")[i].style.color = "#FFAA00";
            }
          }
          else if (res.result == 'API_PLAN') {
            for (var i = 0; i < document.getElementsByClassName("api-plan1").length; i++) {
              document.getElementsByClassName("api-plan1")[i].style.color = "#FFAA00";
            }
          } else if (res.result == 'ENTERPRISE_PLUS') {
            for (var i = 0; i < document.getElementsByClassName("enterprise_plus").length; i++) {
              document.getElementsByClassName("enterprise_plus")[i].style.color = "#FFAA00";
            }
          }
        } else if (res.result == null) {
          projectPlanController.setState({ selectedPlan: '' });
        } else {
          projectPlanController.NotifyFailToCreate(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/";
        }
      }
    });
  }

  fetchBillingTypeApi = () => {
    var projectPlanController = this;
    var projectIdSent = null;
    if (projectPlanController.props.location.projectData != undefined) {
      projectIdSent = projectPlanController.props.location.projectData.projectId;
    } else {
      projectIdSent = localStorage.getItem("currentProjectId")
    }
    $.ajax({
      url: "/api/project-billing-type",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectIdSent
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          projectPlanController.state.billingType = res.result.billingType;
          localStorage.setItem("fixedMonthlyCost", res.result.fixedMonthlyCost)
          projectPlanController.setState(projectPlanController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/";
        }
      }
    });
  }

  goBackToMainPage() {
    if (this.state.selectedPlan != '' || this.state.updatedPlan != '') {
      this.setState({ updatedPlan: '', selectedPlan: '', view: false });
      this.props.history.push('/manage-projects');
    } else if ((this.state.selectedPlan == '' || this.state.updatedPlan == '') && this.state.view == true) {
      this.NotifyNoPlanSelected("Please select plan before proceeding");

    }
  }
  getProjectPlans() {
    var projectPlanController = this;
    var plansOfProject = [];
    var plansArray = [];

    $.ajax({
      url: "/api/project-plan",
      async: false,
      method: 'GET',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          var ticketInform = res.result;
          localStorage.setItem("Project-plans", JSON.stringify(res.result));
          for (var i = 0; i < res.result.length; i++) {
            plansArray[i] = res.result[i]['value'].split(',');
            plansOfProject.push(res.result[i]);
          }

          var ele0 = document.getElementById('free');
          var ele = document.getElementById('starter');
          var ele1 = document.getElementById('profession');
          var ele2 = document.getElementById("premium");
          var ele3 = document.getElementById("enterprise");
          var ele4 = document.getElementById("api-plan");

          if (ele0 != null) {
            for (var i = 0; i < plansArray[0].length; i++) {
              ele0.innerHTML = ele0.innerHTML + '<li>' + plansArray[0][i] + '</li>'
            }
          }
          if (ele != null) {
            for (var i = 0; i < plansArray[1].length; i++) {
              ele.innerHTML = ele.innerHTML + '<li>' + plansArray[1][i] + '</li>'
            }
          }
          if (ele1 != null) {
            for (var i = 0; i < plansArray[2].length; i++) {
              ele1.innerHTML = ele1.innerHTML + '<li>' + plansArray[2][i] + '</li>'
            }
          }
          if (ele2 != null) {
            for (var i = 0; i < plansArray[3].length; i++) {
              ele2.innerHTML = ele2.innerHTML + '<li>' + plansArray[3][i] + '</li>'
            }
          }
          if (ele3 != null) {
            for (var i = 0; i < plansArray[4].length; i++) {
              ele3.innerHTML = ele3.innerHTML + '<li>' + plansArray[4][i] + '</li>'
            }
          }
          if (ele4 != null && plansArray[5] !== undefined) {
            for (var i = 0; i < plansArray[5].length; i++) {
              ele4.innerHTML = ele4.innerHTML + '<li>' + plansArray[5][i] + '</li>'
            }
          }
          projectPlanController.state.plans = res.result;
          projectPlanController.state.planValues = plansArray;
          projectPlanController.state.successResp = true;
          projectPlanController.setState(projectPlanController.state);

        } else {
          projectPlanController.setState({ successResp: false });
          projectPlanController.NotifyFailToCreate(res.result);
        }


      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/";
        }
      }
    });
  }

  notifyNoDowngrade() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Sorry, can’t downgrade from your current plan</b>, {
      position: "top-center"
    });

  }

  proceedPlan0 = () => {
    var projectPlanComponent = this;
    if (projectPlanComponent.state.selectedPlan != 'STARTER' &&
      projectPlanComponent.state.selectedPlan != 'PROFESSIONAL' &&
      projectPlanComponent.state.selectedPlan != 'PREMIUM' &&
      projectPlanComponent.state.selectedPlan != 'ENTERPRISE' &&
      projectPlanComponent.state.selectedPlan != 'ENTERPRISE_PLUS') {
      projectPlanComponent.planApi(projectPlanComponent.state.plans[0].key);
    } else {
      projectPlanComponent.notifyNoDowngrade();
    }
  }
  proceedPlan1 = () => {
    var projectPlanComponent = this;
    if (projectPlanComponent.state.selectedPlan != 'PROFESSIONAL' &&
      projectPlanComponent.state.selectedPlan != 'PREMIUM' &&
      projectPlanComponent.state.selectedPlan != 'ENTERPRISE' &&
      projectPlanComponent.state.selectedPlan != 'ENTERPRISE_PLUS'
    ) {
      projectPlanComponent.planApi(projectPlanComponent.state.plans[1].key);
    } else {
      projectPlanComponent.notifyNoDowngrade();
    }
  }
  proceedPlan2 = () => {
    var projectPlanComponent = this;
    if (projectPlanComponent.state.selectedPlan != 'PREMIUM' && projectPlanComponent.state.selectedPlan != 'ENTERPRISE'
      && projectPlanComponent.state.selectedPlan != 'ENTERPRISE_PLUS') {
      projectPlanComponent.planApi(projectPlanComponent.state.plans[2].key);
    } else {
      projectPlanComponent.notifyNoDowngrade();
    }
  }
  proceedPlan3 = () => {
    var projectPlanComponent = this;
    if (projectPlanComponent.state.selectedPlan != 'ENTERPRISE' && projectPlanComponent.state.selectedPlan != 'ENTERPRISE_PLUS') {
      projectPlanComponent.planApi(projectPlanComponent.state.plans[3].key);
    } else {
      projectPlanComponent.notifyNoDowngrade();
    }
  }
  proceedPlan4 = () => {
    var projectPlanComponent = this;
    if (projectPlanComponent.state.selectedPlan != 'ENTERPRISE_PLUS') {
      projectPlanComponent.planApi(projectPlanComponent.state.plans[4].key);
    } else {
      projectPlanComponent.notifyNoDowngrade();
    }
  }
  proceedPlan5 = () => {
    this.planApi(this.state.plans[5].key);
  }
  proceedPlan6 = () => {
    this.planApi(this.state.plans[6].key);
  }
  NotifyFailToCreate(falseRes) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseRes}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  NotifyNoPlanSelected(result) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;{result}</b>, {
      position: "top-center"
    });

  }

  NotifyPlansAdded() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Plan Updated Successfully</b>, {
      position: "top-center"
    });
    return true;
  }
  moveToMainPage() {
    localStorage.setItem("manageProjectaPathVariable", "");
    var projectPlanController = this;
    if (this.state.selectedPlan != '' || this.state.updatedPlan != '') {
      this.setState({ updatedPlan: '', selectedPlan: '', view: false });

      var projectPlanTimer = setInterval(function () {
        clearTimeout(projectPlanTimer);
        projectPlanController.props.history.push('/projectmgmt');
      }, 50);
    }
  }

  planApi(plan) {
    var projectPlanController = this;
    var projectIdSent = null;
    if (projectPlanController.props.location.projectData != undefined) {
      projectIdSent = projectPlanController.props.location.projectData.projectId;
    } else {
      projectIdSent = localStorage.getItem("currentProjectId")
    }
    var formData = {
      projectPlan: plan,

      id: projectIdSent

    };
    $.ajax({
      url: "/api/project-plan",
      async: false,
      method: 'PATCH',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(formData),
      processData: false,
      contentType: "application/json; charset=UTF-8",
      success: function (res) {
        if (res.success === true) {
          localStorage.setItem("selected-plan", formData.projectPlan);
          projectPlanController.setState({ displayBackBtn: false });
          projectPlanController.setState({ updatedPlan: formData.projectPlan })
          projectPlanController.setState({ projectId: null });
          projectPlanController.NotifyPlansAdded();
          var projectPlanTimer = setInterval(function () {
            clearTimeout(projectPlanTimer);
            projectPlanController.moveToMainPage();
          }, 3000);
        } else {
          projectPlanController.NotifyFailToCreate(res.result);


        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/";
        }
      }

    })
  }

  moveToMainPageFunc(event) {

    if (event.keyCode === 27 && (this.state.selectedPlan != '' || this.state.updatedPlan != '')) {
      this.setState({ updatedPlan: '', selectedPlan: '', view: false });
      this.props.history.push('/projectmgmt');

    } else if (event.keyCode === 27 && (this.state.selectedPlan == '' || this.state.updatedPlan == '') && this.state.view == true) {
      this.NotifyNoPlanSelected("Please select plan before proceeding");

    }
  }
  HandleBackFunctionality() {
    if (window.event) //Internet Explorer
    {

      if (localStorage.getItem("previousPath")) {
        window.location.href = '/sales-desk/projectmgmt/test-and-deploy/DistributionWidget';

      } else if (localStorage.getItem("manageProjectaPathVariable")) {
        window.location.href = '/sales-desk/manage-projects'
      } else {
        window.location.href = '/sales-desk/projectmgmt';
      }
    }
    else //Other browsers for example Chrome
    {
      if (localStorage.getItem("previousPath")) {
        window.location.href = '/sales-desk/projectmgmt/test-and-deploy/DistributionWidget';

      } else if (localStorage.getItem("manageProjectaPathVariable")) {
        window.location.href = '/sales-desk/manage-projects'
      } else {
        window.location.href = '/sales-desk/projectmgmt';
      }
    }
    localStorage.setItem("previousPath", "");
    localStorage.setItem("manageProjectaPathVariable", "");
  }

  handleOnclickHere = () => {
    if (this.state.billingType == "UTTERANCE_BASED") {
      window.location.href = '/sales-desk/utterance-based-pricing';
    } else if (this.state.billingType == "FIXED_PRICE") {
      window.location.href = '/sales-desk/fixed-based-pricing';
    } else {
      window.location.href = '/sales-desk/bot-based-pricing';
    }
  }

  componentDidMount() {
    var thisController = this;
    thisController.state.view = true;
    thisController.setState(thisController.state);
    setTimeout(() => {
      thisController.fetchSelectedProjectPlanApi();
      thisController.fetchBillingTypeApi();
    }, 300);

    document.addEventListener("keydown", this.moveToMainPageFunc, false);
  }
  componentWillUnmount() {
    this.HandleBackFunctionality();
  }

  routeToContactUs = () => {
    window.open("https://www.dhee.ai/contact-us/", "_blank")
  }
  routeToBack = (e) => {
    this.props.history.goBack();
  }

  render() {
    return (<div>
      <Loader

        type="TailSpin"
        color="#282a65"
        visible={this.state.successResp ? false : true}
        height={300}
        width={50}
        style={{ textAlign: 'center', marginTop: window.innerHeight / 6 + "px" }}




      />
      <link href="assets/css/ej2-base.css" rel="stylesheet" />
      <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
      <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
      <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
      <link rel="stylesheet" href="assets/css/ReactToastify.css" />
      <link rel="stylesheet" href="./plugins/font-awesome/css/font-awesome.min.css" />
      <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
      <link rel="stylesheet" href="./assets/css/adminlte.css" />
      <link rel="stylesheet" href="./assets/css/styles.css" />
      <link rel="stylesheet" href="./assets/css/custom-style.css" />
      <link rel="stylesheet" href="./plugins/iCheck/all.css" />

      <div className="wrapper " style={{ display: this.state.successResp ? 'block' : 'none' }}>

        <nav className="navbar navbar-default" role="navigation" >

          <div className="container-fluid">
            <div className="navbar-header" style={{ width: '100%' }}>
              <div className="navbbox" >
                <a className="navbar-brand" href="https://www.dhee.ai" style={{ width: '100%' }}>
                  <div className="row col-md-12">
                    <div className="col-md-12">
                      <img src="assets/images/dheeai.png" alt="" Align="left" style={{ height: "53px", width: "150px" }} />
                      <div Align="center" style={{ marginTop: '20px' }}>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </nav>

        <div className="">
          <div className="row">
            <div className="col-12">
              <div className="">
                <div className="card-body " style={{ padding: '0% 2.5% 2.5% 2.5%' }}>
                  <div className='row'>
                    <div className='col-sm-6'>

                      <div className="step1Box">
                        <ToastContainer className="Toast-at-center" />
                        <div className="crplan">
                          Let's choose a plan that’s right for you
                        </div><br />
                        <div id="price-details">
                          {this.state.selectedPlan == '' ? "" :
                            <div>
                              <span>
                                You will be billed only when you deploy your project.
                              </span><br /><br />
                              <span>
                                The wallet credits that you receive will be consumed based on your usage
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>

                    <div className='col-sm-6' Align='right'>
                      <img src="./assets/images/deleteCross.png" style={{ cursor: 'pointer' }}
                        onClick={(e) => this.routeToBack(e)} />

                    </div>
                  </div>
                  <div className="row">


                    <div className="col-3" >
                      <div className={this.state.selectedPlan === 'STARTER' ? "tborder tileHeadBorder" : "priceCard tborder primeclr"} style={{ minHeight: "470px" }}>
                        <div className="pric_head starter1">
                          <h3 className="planTitle starter1" style={{ fontSize: '20px' }}>{this.state.plans[1].key}</h3>
                          <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="starter1"><b>₹ 2,000</b></span>
                            <span className="starter1" style={{ fontSize: "10px" }}> / recharge</span>
                          </h4>
                          <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="starter1"><b>Rate ₹ 1.1</b></span>
                            <span className="starter1" style={{ fontSize: "10px" }}> / minute</span>
                          </h4>
                        </div>
                        <div className="pric_body">
                          <ul className="priceFeature" id="starter">
                            <li>Agent on website widget &amp; popular social sales-desks</li>
                            <li>2 Languages(e.g English and Hindi)</li>
                            <li>20 FAQs</li>
                            <li>2 Intents</li>
                            <li>Dashboard with reports</li>
                            <li>Delegate chat to humans</li>
                            <li>Unlimited messages</li>
                          </ul>
                        </div>
                        <div className="pric_footer">

                          <button className="btn btn-arrow" hidden={this.state.selectedPlan === 'STARTER' ? true : false} onClick={this.proceedPlan1}>
                            <span>Select Plan
                              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                              </svg>
                            </span>
                          </button>
                          <label
                            style={{
                              color: 'rgb(58, 110, 232)',
                              fontWeight: '400',
                              textAlign: 'center',
                              fontSize: '1rem',
                              lineHeight: '1.5',
                              letterSpacing: '1.5px',
                              padding: '0.8rem 1.8rem!important'
                            }}
                            hidden={this.state.selectedPlan === 'STARTER' ? false : true}>
                            <img style={{ marginRight: '3px' }} src="assets/images/done.svg" />
                            SELECTED PLAN
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className={this.state.selectedPlan === 'PROFESSIONAL' ? "tborder tileHeadBorder" : "priceCard tborder primeclr"} style={{ minHeight: "470px" }}>
                        <div className="pric_head profession1">
                          <h3 className="profession1" style={{ fontSize: '20px' }}>{this.state.plans[2].key}</h3>
                          <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="profession1"><b>₹ 4,000</b></span>
                            <span className="profession1" style={{ fontSize: "10px" }}> / recharge</span>
                          </h4>
                          <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="profession1"><b>Rate ₹ 1</b></span>
                            <span className="profession1" style={{ fontSize: "10px" }}> / minute</span>
                          </h4>
                        </div>
                        <div className="pric_body">
                          <ul className="priceFeature" id="profession">
                            <li>Agent on website widget &amp; popular social sales-desks</li>
                            <li>4 Languages</li>
                            <li>40 FAQs</li>
                            <li>6 Intents</li>
                            <li>Dashboard with reports</li>
                            <li>Delegate chat to humans</li>
                            <li>Unlimited messages</li>
                          </ul>
                        </div>
                        <div className="pric_footer"><br /><br />

                          <button className="btn btn-arrow" hidden={this.state.selectedPlan === 'PROFESSIONAL' ? true : false} onClick={this.proceedPlan2}>
                            <span>Select Plan
                              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                              </svg>
                            </span>
                          </button>
                          <label
                            style={{
                              color: 'rgb(58, 110, 232)',
                              fontWeight: '400',
                              textAlign: 'center',
                              fontSize: '1rem',
                              lineHeight: '1.5',
                              letterSpacing: '1.5px',
                              padding: '0.8rem 1.8rem!important'
                            }}
                            hidden={this.state.selectedPlan === 'PROFESSIONAL' ? false : true}>
                            <img style={{ marginRight: '3px' }} src="assets/images/done.svg" />
                            SELECTED PLAN
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className={this.state.selectedPlan === 'PREMIUM' ? "tborder tileHeadBorder" : "priceCard tborder primeclr"} style={{ minHeight: "470px" }}>
                        <div className="pric_head premium1">
                          <h3 className="planTitle premium1" style={{ fontSize: '20px' }}>{this.state.plans[3].key}</h3>
                          <h4 className="planPrice premium1" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="premium1"><b>₹ 6,000</b></span>
                            <span className="premium1" style={{ fontSize: "10px" }}> / recharge</span>
                          </h4>
                          <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="premium1"><b>Rate ₹ 0.9</b></span>
                            <span className="premium1" style={{ fontSize: "10px" }}> / minute</span>
                          </h4>
                        </div>
                        <div className="pric_body">
                          <ul className="priceFeature" id="premium">
                            <li>Agent on website widget &amp; popular social sales-desks</li>
                            <li>6 Languages</li>
                            <li>90 FAQs, 4 Documents</li>
                            <li>15 Intents</li>
                            <li>Dashboard with reports</li>
                            <li>Delegate chat to humans</li>
                            <li>Unlimited messages</li>
                          </ul>
                        </div><br />
                        <div className="pric_footer">

                          <button className="btn btn-arrow" hidden={this.state.selectedPlan === 'PREMIUM' ? true : false} onClick={this.proceedPlan3}>
                            <span>Select Plan
                              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                              </svg>
                            </span>
                          </button>
                          <label
                            style={{
                              color: 'rgb(58, 110, 232)',
                              fontWeight: '400',
                              textAlign: 'center',
                              fontSize: '1rem',
                              lineHeight: '1.5',
                              letterSpacing: '1.5px',
                              padding: '0.8rem 1.8rem!important'
                            }}
                            hidden={this.state.selectedPlan === 'PREMIUM' ? false : true}>
                            <img style={{ marginRight: '3px' }} src="assets/images/done.svg" />
                            SELECTED PLAN
                          </label>
                        </div>
                      </div>
                    </div>



                    <div className="col-3">
                      <div className={this.state.selectedPlan === 'ENTERPRISE' ? "tborder tileHeadBorder" : "priceCard tborder primeclr"} style={{ minHeight: "470px" }}>
                        <div className="pric_head enterprise1">
                          <h3 className="planTitle enterprise1" style={{ fontSize: '20px' }}>{this.state.plans[4].key}</h3>
                          <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="enterprise1"><b>₹ 20,000</b></span>
                            <span className="enterprise1" style={{ fontSize: "10px" }}> / recharge</span>
                          </h4>
                          <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="enterprise1"><b>Rate ₹ 0.8</b></span>
                            <span className="enterprise1" style={{ fontSize: "10px" }}> / minute</span>
                          </h4>

                        </div>
                        <div className="pric_body" >
                          <ul className="priceFeature" id="enterprise">
                            <li>Agent on website widget &amp; popular social sales-desks</li>
                            <li>9 Languages</li>
                            <li>Upto 300 FAQs, 10 Documents</li>
                            <li>Upto 60 Intents</li>
                            <li>Dashboard with reports</li>
                            <li>Delegate chat to humans</li>
                            <li>Unlimited messages</li>
                          </ul>
                        </div>
                        <div className="pric_footer">

                          <button className="btn btn-arrow" hidden={this.state.selectedPlan === 'ENTERPRISE' ? true : false} onClick={this.proceedPlan4}>
                            <span>Select Plan
                              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                              </svg>
                            </span>
                          </button>
                          <label
                            style={{
                              color: 'rgb(58, 110, 232)',
                              fontWeight: '400',
                              textAlign: 'center',
                              fontSize: '1rem',
                              lineHeight: '1.5',
                              letterSpacing: '1.5px',
                              padding: '0.8rem 1.8rem!important'
                            }}
                            hidden={this.state.selectedPlan === 'ENTERPRISE' ? false : true}>
                            <img style={{ marginRight: '3px' }} src="assets/images/done.svg" />
                            SELECTED
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-3">
                      <div className={this.state.selectedPlan === 'ENTERPRISE_PLUS' ? "tborder tileHeadBorder" : "priceCard tborder primeclr"} style={{ minHeight: "470px" }}>
                        <div className="pric_head enterprise_plus">
                          <h3 className="planTitle enterprise_plus" style={{ fontSize: '20px' }}>{this.state.plans[6].key}</h3>
                          <h4 className="planPrice" style={{ backgroundColor: "#F9F9FB", fontSize: '18px' }}>
                            <span className="enterprise_plus"><b><span style={{ fontSize: "10px" }}>Starting from</span>&nbsp;&nbsp;₹ 2 Lakh</b></span>
                            <span className="enterprise_plus" style={{ fontSize: "10px" }}> / month</span>
                          </h4>
                        </div>
                        <div className="pric_body" style={{ marginTop: '30px' }}>
                          <ul className="priceFeature" id="enterprise">
                            <li>Completely customized</li>
                          </ul>
                        </div>
                        <div className="pric_footer">

                          <button className="btn btn-arrow" hidden={this.state.selectedPlan === 'ENTERPRISE_PLUS' ? true : false} onClick={this.proceedPlan6}>
                            <span> Email Us
                              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.49 31.49" xmlSpace="preserve">
                                <path strokeWidth={3} style={{}} d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z" />
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                              </svg>
                            </span>
                          </button>
                          <label
                            style={{
                              color: 'rgb(58, 110, 232)',
                              fontWeight: '400',
                              textAlign: 'center',
                              fontSize: '1rem',
                              lineHeight: '1.5',
                              letterSpacing: '1.5px',
                              padding: '0.8rem 1.8rem!important'
                            }}
                            hidden={this.state.selectedPlan === 'ENTERPRISE_PLUS' ? false : true}>
                            <img style={{ marginRight: '3px' }} src="assets/images/done.svg" />
                            SELECTED
                          </label>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="crplan" Align='center' style={{ padding: "20px", }}>Add voice capability to your agents for just extra ₹ 1.95 / minute !</div>

          <div Align="center" style={{ paddingBottom: "20px", fontSize: "18px", color: "#282a65", cursor: "default" }}>
            Do you have larger content or need on-premise installation?&nbsp;&nbsp;
            <a style={{ cursor: "pointer" }} onClick={this.routeToContactUs}>Contact us</a>
          </div>

          <div Align="center">
            <button className="btn btn-primary saveChangesBtn"
              style={{ display: this.state.displayBackBtn ? 'block' : 'none' }}
              title="Back" onClick={this.goBackToMainPage}>
              Back
            </button>
          </div>
          <br />
        </div>
      </div>
    </div>)
  }
}
export default ProjectPlanSettings;



// WEBPACK FOOTER //
// ./src/sales-desk/ProjectPlanSettings.js